module.exports = __webpack_public_path__ + "static/media/general_error.a9d9b643.png";